const initMenu = (lenis) => {
	const $body = document.body;
	const h = document.querySelector('.header-logo-box').offsetHeight;

	lenis.on('scroll', ({ animatedScroll, direction }) => {
		// console.log(animatedScroll);
		animatedScroll > h ? $body.classList.add('fixed-menu') : $body.classList.remove('fixed-menu');
		direction > 0 ? $body.classList.add('drop-menu') : $body.classList.remove('drop-menu');

		// ScrollTrigger.update();
	});

	// 菜单按钮 (移动端)
	const toggleMenuBtn = document.querySelector('.js-toggle-menu');
	if (toggleMenuBtn) {
		toggleMenuBtn.addEventListener('click', () => {
			$body.classList.toggle('menu-open');
		});
	}

	window.addEventListener('resize', () => {
		$body.classList.remove('menu-open');
	});

	const hmLinks = document.querySelectorAll('.hm-link');
	const hmLinksBg = document.querySelectorAll('.hm-link-bg');
	hmLinks.forEach((hmlink, index) => {
		hmlink.addEventListener('mouseenter', () => {
			hmLinksBg.forEach((hmlinkbg, i) => {
				hmlinkbg.classList.toggle('hover', i === index);
			});
		});
		hmlink.addEventListener('mouseleave', () => {
			hmLinksBg.forEach((hmlinkbg, i) => {
				hmlinkbg.classList.remove('hover', i === index);
			});
		});
	});

	// 返回顶部
	const gotop = document.querySelector('.js-gotop');
	if (gotop) {
		gotop.addEventListener('click', () => {
			lenis.scrollTo(0);
		});
	}

	function setupVerticalGrid(container, totalItems, columns = 4) {
		const rows = Math.ceil(totalItems / columns);
		container.style.setProperty('--columns', columns);
		container.style.setProperty('--rows', rows);
	}

	const gridClients = document.querySelector('.grid-clients');
	if (gridClients) {
		const total = gridClients.querySelectorAll('li').length;
		window.addEventListener('resize', () => {
			let columns = window.innerWidth > 1024 ? 4 : 2;
			setupVerticalGrid(gridClients, total, columns);
		});
		const resizeEvent = new Event('resize');
		window.dispatchEvent(resizeEvent);
	}

	const serviceSticky = document.querySelectorAll('.service-sticky');
	if (serviceSticky.length) {
		lenis.on('scroll', ({ animatedScroll, direction }) => {
			if (window.innerWidth > 1024) {
				serviceSticky.forEach((stickyElm, index) => {
					const stickyTop = stickyElm.dataset.sticky;
					const h = window.innerWidth > 2160 ? stickyTop : (stickyTop * 2160) / window.innerWidth;
					// console.log(stickyElm.getBoundingClientRect().top, index, 'h:', h);
					if (stickyElm.getBoundingClientRect().top <= h) {
						stickyElm.classList.add('z-10');
					} else {
						stickyElm.classList.remove('z-10');
					}
				});
			}
		});
	}

	const pageTitle = document.querySelector('.js-page-title');
	if (pageTitle) {
		// 使用 innerHTML 保留 HTML 标签（包括 <br>）
		const titleHTML = pageTitle.innerHTML;

		// 按 <br> 标签拆分，并将 <br> 标签与后面的单词组合
		const parts = titleHTML.trim().split(/(<br[^>]*>)/i);
		const result = [];

		for (let i = 0; i < parts.length; i++) {
			const part = parts[i].trim();

			if (!part) continue; // 跳过空字符串

			// 如果是 <br> 标签
			if (part.match(/^<br[^>]*>$/i)) {
				// 获取下一个部分（可能包含多个单词）
				const nextPart = i + 1 < parts.length ? parts[i + 1].trim() : '';
				if (nextPart) {
					// 将下一个部分按空格拆分成单词
					const nextWords = nextPart.split(/\s+/).filter((word) => word.length > 0);
					if (nextWords.length > 0) {
						// 将 <br> 标签与第一个单词组合
						result.push(part + nextWords[0]);
						// 如果还有其他单词，单独添加
						if (nextWords.length > 1) {
							result.push(...nextWords.slice(1));
						}
					}
					i++; // 跳过下一个部分，因为已经处理了
				} else {
					result.push(part);
				}
			} else {
				// 普通单词，按空格拆分
				const words = part.split(/\s+/).filter((word) => word.length > 0);
				result.push(...words);
			}
		}

		// console.log('原始HTML:', titleHTML);
		// console.log('拆分结果（br标签与后续单词组合）:', result);

		let str = '';
		result.forEach((w, i) => {
			// 检查是否以 <br 开头（包含 br 标签）
			if (w.match(/^<br[^>]*>/i)) {
				// 提取 br 标签和后面的文本
				const brMatch = w.match(/^(<br[^>]*>)(.*)$/i);
				if (brMatch) {
					const brTag = brMatch[1]; // <br class="lg:hidden">
					const textAfterBr = brMatch[2]; // conversation
					str += `${brTag}<span class="inline-block" data-aos="clip-up" data-aos-duration="1000" data-aos-delay="${i * 200}">${textAfterBr}</span> `;
				} else {
					// 如果只是 br 标签没有后续文本
					str += `${w} `;
				}
			} else {
				// 普通单词
				str += `<span class="inline-block" data-aos="clip-up" data-aos-duration="1000" data-aos-delay="${i * 200}">${w}</span> `;
			}
		});

		// console.log(str);
		pageTitle.innerHTML = str;
	}
};

export { initMenu };
